import React from "react";
import Navigation from "../components/Navigation";
import LightSpeed from "react-reveal";
export default function Skills() {
	return (
		<>
			<div>
				<Navigation />
				<div className="container mx-auto p-5">
					<h1 className="text-center text-2xl">
						Knowledge skills in website technology
					</h1>
					<div className=" shadow-md bg-secondColors-primary h-full rounded-lg p-5">
						<h2 className="text-2xl">Language</h2>
						<LightSpeed left>
							<div className="shadow-md w-2/3 block mx-auto bg-secondColors-dark h-full rounded-lg p-5 mt-5">
								<div class="grid grid-cols-2 auto-cols-max gap-2">
									<div>
										<div className=" shadow-md bg-secondColors-primary h-full rounded-lg p-5">
											PHP
										</div>
									</div>
									<div>
										<div className=" shadow-md bg-secondColors-primary h-full rounded-lg p-5">
											JAVASCRIPT
										</div>
									</div>
								</div>
							</div>
						</LightSpeed>

						<h2 className="text-2xl">Frontend</h2>
						<LightSpeed left>
							<div className="shadow-md  bg-secondColors-dark h-full rounded-lg p-5 mt-5">
								<div class="grid grid-cols-4 auto-cols-max gap-5">
									<div>
										<div className=" shadow-md bg-secondColors-primary h-full rounded-lg p-5">
											HTML5
										</div>
									</div>
									<div>
										<div className=" shadow-md bg-secondColors-primary h-full rounded-lg p-5">
											CSS3
										</div>
									</div>
									<div>
										<div className=" shadow-md bg-secondColors-primary h-full rounded-lg p-5">
											JAVASCRIPT
										</div>
									</div>
									<div>
										<div className=" shadow-md bg-secondColors-primary h-full rounded-lg p-5">
											BOOTSTRAP
										</div>
									</div>
									<div>
										<div className=" shadow-md bg-secondColors-primary h-full rounded-lg p-5">
											React
										</div>
									</div>
								</div>
							</div>
						</LightSpeed>

						<h2 className="text-2xl mt-3">Backend</h2>
						<LightSpeed left>
							<div className="shadow-md bg-secondColors-dark h-full rounded-lg p-5 mt-5">
								<div class="grid grid-cols-2 auto-cols-max gap-2">
									<div>
										<div className=" shadow-md bg-secondColors-primary h-full rounded-lg p-5">
											Express Js
										</div>
									</div>
									<div>
										<div className=" shadow-md bg-secondColors-primary h-full rounded-lg p-5">
											Laravel
										</div>
									</div>
								</div>
							</div>
						</LightSpeed>
						<h2 className="text-2xl mt-3">Database</h2>
						<LightSpeed left>
							<div className="shadow-md bg-secondColors-dark h-full rounded-lg p-5 mt-5">
								<div class="grid grid-cols-2 auto-cols-max gap-2">
									<div>
										<div className=" shadow-md bg-secondColors-primary h-full rounded-lg p-5">
											Mysql
										</div>
									</div>
									<div>
										<div className=" shadow-md bg-secondColors-primary h-full rounded-lg p-5">
											Mongodb
										</div>
									</div>
								</div>
							</div>
						</LightSpeed>
						<h2 className="text-2xl mt-3">Design</h2>
						<LightSpeed left>
							<div className="shadow-md bg-secondColors-dark h-full rounded-lg p-5 mt-5">
								<div class="grid grid-cols-1 auto-cols-max gap-1">
									<div>
										<div className="w-1/6 justify-center shadow-md bg-secondColors-primary h-full rounded-lg p-5">
											Figma
										</div>
									</div>
								</div>
							</div>
						</LightSpeed>
						<h2 className="text-2xl mt-3">Version Control</h2>
						<div className="shadow-md bg-secondColors-dark h-full rounded-lg p-5 mt-5">
							<div class="grid grid-cols-1 auto-cols-max gap-1">
								<div>
									<div className="w-1/6 justify-center shadow-md bg-secondColors-primary h-full rounded-lg p-5">
										Github
									</div>
								</div>
							</div>
						</div>
						<LightSpeed left>
							<h2 className="text-2xl mt-3">Currently in the learning stage</h2>
							<div className="shadow-md  bg-secondColors-dark h-full rounded-lg p-5 mt-5">
								<div class="grid grid-cols-4 auto-cols-max gap-5">
									<div>
										<div className=" shadow-md bg-secondColors-primary h-full rounded-lg p-5">
											TypeScript
										</div>
									</div>
									<div>
										<div className=" shadow-md bg-secondColors-primary h-full rounded-lg p-5">
											Redux
										</div>
									</div>
									<div>
										<div className=" shadow-md bg-secondColors-primary h-full rounded-lg p-5">
											Vue Js
										</div>
									</div>
									<div>
										<div className=" shadow-md bg-secondColors-primary h-full rounded-lg p-5">
											Tailwind
										</div>
									</div>
									<div>
										<div className=" shadow-md bg-secondColors-primary h-full rounded-lg p-5">
											Golang
										</div>
									</div>
								</div>
							</div>
						</LightSpeed>
					</div>
				</div>
			</div>
		</>
	);
}
